import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const validate = (value, files, rules) => {
  let isValid = true
  let message = ''
  
  for (let rule in rules) {

    switch (rule) {
      case 'isRequired': 
        isValid = isValid && requiredValidator(value)
        message = isValid ? '' : 'Dit veld is verplicht.'
        break;

      case 'minLength': 
        isValid = isValid && minLengthValidator(value, rules[rule])
        message = isValid ? '' : `Minimaal ${rules[rule]} karakters.`
        break;
		    
      case 'isEmail': 
        isValid = isValid && emailValidator(value)
        message = isValid ? '' : 'Vul een geldig e-mailadres in.'
        break;

      case 'min': 
        isValid = isValid && minValidator(value, rules[rule])
        message = isValid ? '' : `Het minimum is ${rules[rule]}.`
        break;

      case 'max': 
        isValid = isValid && maxValidator(value, rules[rule])
        message = isValid ? '' : `Het maximum is ${rules[rule]}.`
        break;
      
      case 'step': 
        isValid = isValid && stepValidator(value, rules[rule])
        message = isValid ? '' : `Ongeldig getal format.`
        break;

      case 'maxSize': 
        isValid = isValid && maxSizeValidator(files, rules[rule])
        let mbs = rules[rule] / 1000000
        message = isValid ? '' : `Het bestand is te groot. De maximale grootte is ${mbs} MB.`
        break;
      
      default: 
        isValid = true
        message = ''
    }

    // Break the loop once we hit invalid
    if ( ! isValid ) {
      return { 
        'status': isValid,
        'message': message
      }
    }

  }
  
  return { 
    'status': isValid,
    'message': message
  }
}

/**
 * Check if field is required    
 */
const requiredValidator = value => {
  return value.trim() !== ''
}

/**
 * Check if value is long enough       
 */
const minLengthValidator = (value, minLength) => {
  return value.length >= minLength
}

/**
 * Check if email is valid
 */
const emailValidator = value => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase())
}

/**
 * Check if value is low enough      
 */
const minValidator = (value, min) => {
  return Number(value) >= min
}

/**
 * Check if value is high enough       
 */
const maxValidator = (value, max) => {
  return Number(value) <= max
}

/**
 * Check step for number input      
 */
const stepValidator = (value, step) => {
  let number = Number(value)

  /**
   * We do allow zero, in case we have the rule min=0.
   * We'll handle zero in minValidator.
   */
  if ( number === 0 ) {
    return true;
  }

  // Check if valid number
  if ( ! number ) {
    return false
  }

  // If step integers only
  if (step === '1') {
    return Number.isInteger(number)
  }

  return number
}

/**
 * Check if value size is low enough   
 */
const maxSizeValidator = (files, maxSize) => {
  return (files.length > 0 && files[0].size <= maxSize)
}

export default validate



// WEBPACK FOOTER //
// ./src/js/personalizer/helpers/validate.js